import React from 'react'
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';

import App from './components/App.js';

if (!window.localStorage.getItem("firstReload")) {
  window.localStorage.setItem("firstReload", "true");
  window.location.reload(true)
}

ReactDOM.render(
  <BrowserRouter basename='/equipmentfinder'>
    <App />
  </BrowserRouter>,
  document.getElementById('root'));